module.exports = __webpack_public_path__ + "img/shadow.6162b1ba.png";